<mat-card *ngIf="item">
	<div class="obg-m-deposit-bonus-item-info">
		<div class="obg-m-deposit-bonus-item-header">
			<div
				*ngIf="item.image"
				class="obg-m-deposit-bonus-item-img"
				[ngStyle]="{ 'background-image': 'url(' + item.image.url + ')' }"
			></div>
			<h2>{{ item.title }}</h2>
			<mat-card-subtitle *ngIf="item.validUntil"
				>{{ "bonus.expires" | translate }} {{ item.validUntil | date: "longDate" }}</mat-card-subtitle
			>
		</div>
		<p [innerHtml]="item.description"></p>
		<button color="primary" mat-raised-button (click)="getBonus.next()">
			{{ "bonus.claim-bonus" | translate }}
		</button>
	</div>
	<mat-expansion-panel
		*ngIf="item.termsAndConditions"
		#tcPanel="matExpansionPanel"
		class="obg-m-deposit-bonus-item-tc"
		hideToggle
	>
		<mat-expansion-panel-header expandedHeight="50px" collapsedHeight="50px">
			<span [innerHtml]="'general.terms-and-conditions' | translate"></span>
			<span [class]="tcPanel.expanded ? 'ico-chevron-up' : 'ico-chevron-down'"></span>
		</mat-expansion-panel-header>
		<p [innerHtml]="item.termsAndConditions"></p>
		<div class="obg-m-deposit-bonus-item-collapse" (click)="tcPanel.close()">
			<span class="ico-chevron-up"></span>
		</div>
	</mat-expansion-panel>
</mat-card>
